import { Card, CardSize } from '@ollico/optiiva-ui-sdk';
import { BookingResource } from '@ollico/optiiva-ui-sdk/lib/types/resources';
import React, { useEffect, useState } from 'react';
import Api from '../../../api';
import AppointmentsTable from '../../../components/appointments/AppointmentsTable';
import Loader from '../../../components/misc/Loader';
import { useSessionContext } from '../../../context/auth';

const ThisWeeksAppointments = (): JSX.Element => {
    const [appointments, setAppointments] = useState<BookingResource[]>([]);
    const [processing, setProcessing] = useState(true);
    const {
        context: { token },
    } = useSessionContext();

    const loadData = () => {
        setProcessing(true);

        Api.appointments(token as string)
            .restOfWeek()
            .then((data) => {
                setAppointments(data);
            })
            .finally(() => {
                setProcessing(false);
            });
    };

    useEffect(() => loadData(), []);

    return (
        <Card heading="Appointments this week" size={CardSize.SM}>
            {processing ? (
                <Loader />
            ) : (
                <>
                    {appointments.length > 0 ? (
                        <AppointmentsTable
                            refreshPage={() => loadData()}
                            isPast={false}
                            appointments={appointments}
                        />
                    ) : (
                        <span>There are no appointments scheduled for the rest of the week</span>
                    )}
                </>
            )}
        </Card>
    );
};

export default ThisWeeksAppointments;
